import { useEffect, useState } from "react";
import { useGetRenewalAccept } from "../api/v1";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

export const useGetRenewalAcceptedData = () => {
   const filterData = useDashboardFilterContext();
  const [renewalAcceptedData, setRenewalAcceptedData] = useState({});
  const { renewalAccepted, isLoading } = useGetRenewalAccept(filterData);
 
  useEffect(() => {
    if (!renewalAccepted || renewalAccepted?.length === 0) return;

    let data = {};
    renewalAccepted?.forEach((element) => {
      (data["totalRenewalSentCount"] = element?.renewalSentCount),
        (data["totalRenewalSentTotalAmount"] = element?.renewalSentTotalAmount),
        (data["renewalAcceptedPercentage"] = element?.renewalAcceptedPercentage);
      data["renewalAcceptedCount"] = element?.renewalAcceptedCount;
    });

    setRenewalAcceptedData(data);
  }, [renewalAccepted]);
  return { renewalAcceptedData, isLoading };
};
